import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { LANGUAGE_BY_COUNTRY, LANGUAGES_BY_COUNTRY } from '@tectonics/translate/enums/language-by-country.enum';
import { getCurrentLanguage } from '@tectonics/controller/language/language-service';

const initI18n = (country) => {
  const defaultLanguage = LANGUAGE_BY_COUNTRY[country];
  if (!defaultLanguage) {
    throw new Error(`No language found for country code: ${country}`);
  }

  const storedLanguage = getCurrentLanguage();
  const supportedForCountry = (LANGUAGES_BY_COUNTRY[country] || []).map(l => l.code);
  const language = storedLanguage && supportedForCountry.includes(storedLanguage)
    ? storedLanguage
    : defaultLanguage;

  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: language,
      debug: Boolean(process.env.NODE_ENV !== 'production'),
      supportedLngs: ['en', 'es', 'pt', 'ar', 'tr', 'id', 'th'],
      fallbackLng: 'en',
      detection: {
        order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
        caches: ['cookie'],
      },
      backend: {
        loadPath: '/translate/locales/{{lng}}/{{ns}}.json',
      },
    });
};

export default initI18n;
